import { useState } from "react";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/app/components/shadcn/accordion";
import { Checkbox } from "@/app/components/shadcn/checkbox";
import { Input } from "@/app/components/shadcn/input";
import { Label } from "@/app/components/shadcn/label";
import {
  FilterListGroup,
  ListFilterKey,
} from "@/app/lib/features/filters/filters.types";
import useFilters from "@/app/lib/features/filters/filters.hook";
import useModal from "@/app/lib/features/modal/modal.hook";
import FilterColorSection from "./FilterColorSection";

interface FilterListSectionProps {
  filter: FilterListGroup;
  disableMinimumFilter?: boolean;
}

const FilterListSection = ({ filter, disableMinimumFilter }: FilterListSectionProps) => {
  const { toggleList, selected, isSelected, blocksLastContextFilter } =
    useFilters();
  const { createModal } = useModal();
  const [search, setSearch] = useState("");

  if (filter.items.length === 0) return null;

  if (filter.key === "color") {
    return <FilterColorSection filter={filter} disableMinimumFilter={disableMinimumFilter} />;
  }

  const filtered = filter.items.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()),
  );

  const key = filter.key as ListFilterKey;
  const selectedCount = (selected[key] as (string | number)[]).length;

  // Kural yalnızca kategori / ürün grubu / alt kategori üçlüsünde ve yalnızca
  // sayfa bağlamı bunlardan birini seçili getirdiyse geçerli — kararın tamamı
  // blocksLastContextFilter'da, gerekçesi orada yazıyor.
  const handleToggle = (itemId: string | number) => {
    if (!disableMinimumFilter && blocksLastContextFilter(key, itemId)) {
      createModal("filter-minimum-warning");
      return;
    }
    toggleList(key, itemId);
  };

  return (
    <AccordionItem value={filter.key}>
      <AccordionTrigger className="hover:bg-muted p-2 my-2">
        {filter.title}
        {selectedCount > 0 && (
          <span className="ml-auto mr-2 w-5 h-5 flex items-center justify-center text-xs bg-black text-white rounded-full shrink-0">
            {selectedCount}
          </span>
        )}
      </AccordionTrigger>
      <AccordionContent className="p-1">
        {filter.search && (
          <Input
            placeholder={`${filter.title} Ara`}
            className="mb-3"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        )}
        <div className="max-h-55 overflow-y-auto space-y-1.5">
          {filtered.map((item) => {
            const itemId = `${filter.key}-${item.id}`;
            const checked = isSelected(key, item.id);
            return (
              <div key={itemId} className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Checkbox
                    id={itemId}
                    checked={checked}
                    onCheckedChange={() => handleToggle(item.id)}
                  />
                  <Label
                    htmlFor={itemId}
                    className="text-[13px] text-muted-foreground font-normal cursor-pointer"
                  >
                    {item.name}
                  </Label>
                </div>
              </div>
            );
          })}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default FilterListSection;
